import React from 'react'
import { FaFacebookF, FaInstagram, FaSquareFacebook, FaSquareThreads, FaYoutube } from 'react-icons/fa6'
import { Link } from 'react-router-dom'

const Footer = () => {
  const slugData = {
    slug: "terms-conditions"
  };
  return (
    <section className='custom-footer-section py-5'>
      <div className="row py-4 m-0">
        <div className="col-md-12 col-lg-4 custom-footer-content mb-3 p-0">
          <h4>Find Us</h4>
          <ul className=" p-0 mt-3">
            <li className='custom-footer-address my-1 text-center text-wrap'>A-32 1st Floor National Market, <br /> Peeragarhi, New Delhi - 110087</li>
            <li className='custom-footer-number my-2 d-flex flex-wrap justify-content-center align-items-center gap-2  text-center'><span>Ph : +91 89201-93397 </span>,<span>Whatsapp : +91 70118-58174</span></li>
            <li className='custom-footer-email-link my-2 p-0 m-0 text-center'><a href="" className=' px-2 m-0 text-center w-100'>Operations@sortedtrips.in</a></li>
          </ul>
        </div>
        <div className="col-md-12 col-lg-4 custom-footer-content mb-3 p-0">
          <h4>Quick Link</h4>
          <ul className="custom-footer-links p-0 mt-3">
            <li className='custom-footer-link text-center'><Link to="/gallery">Gallery</Link></li>
            {/* <li className='custom-footer-link text-center'><a href="">Clipping Path</a></li> */}
            <li className='custom-footer-link text-center'><Link to="/privacyandpolicy">Privacy & Policy</Link></li>
            <li className='custom-footer-link text-center'><Link to="/termsandconditions">Terms & Conditions</Link></li>
          </ul>
        </div>
        <div className="col-md-12 col-lg-4 custom-footer-content mb-3 p-0">
          <h4 className='mb-3'>Follow Us</h4>
          <ul className="custom-footer-links d-flex p-0 gap-2 mt-2">
            <li className='custom-footer-link custom-footer-social-link'><a href="https://www.facebook.com/share/17FC6dWk6o/?mibextid=wwXIfr" target='_blank'><FaSquareFacebook className='custom-user-social-icons' /></a></li>
            <li className='custom-footer-link custom-footer-social-link'><a href="https://www.threads.com/@sortedtrips.in" target='_blank'><FaSquareThreads className='custom-user-social-icons' /></a></li>
            <li className='custom-footer-link custom-footer-social-link'><a href="https://youtube.com/@somewherewithrishabh?si=nMZDyPQKlRBga97-" target='_blank'><FaYoutube className='custom-user-social-icons' /></a></li>
            <li className='custom-footer-link custom-footer-social-link'><a href="https://www.instagram.com/sortedtrips.in/" target='_blank'><FaInstagram className='custom-user-social-icons' /></a></li>
          </ul>
        </div>
        <div className="col-lg-12 text-center mt-5">
          <p className='custom-footer-copyright'>Copyright @2025 | Designed With by SortedTrips</p>
        </div>
      </div>
    </section>
  )
}

export default Footer